import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=41d52f6a&scoped=true&"
import script from "./StockEdit.vue?vue&type=script&lang=js&"
export * from "./StockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d52f6a",
  null
  
)

export default component.exports